'use client';

import type * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import {ChevronDown} from 'lucide-react';

import {cn} from '@/modules/foundation/shared/tailwind';

const Accordion = AccordionPrimitive.Root;

type AccordionItemProps = React.ComponentProps<typeof AccordionPrimitive.Item>;
const AccordionItem = ({className, ref, ...props}: AccordionItemProps) => (
	<AccordionPrimitive.Item ref={ref} className={cn(className)} {...props} />
);

type AccordionTriggerProps = React.ComponentProps<typeof AccordionPrimitive.Trigger>;
const AccordionTrigger = ({className, children, ref, ...props}: AccordionTriggerProps) => (
	<AccordionPrimitive.Header className="flex">
		<AccordionPrimitive.Trigger
			ref={ref}
			className={cn(
				'flex flex-1 cursor-pointer items-center justify-between border-b border-neutral-100/40 py-4 text-left transition-all hover:underline [&[data-state=open]>svg]:rotate-180',
				className,
			)}
			{...props}
		>
			{children}

			<ChevronDown
				size={20}
				aria-hidden
				className="shrink-0 transition-transform duration-200"
			/>
		</AccordionPrimitive.Trigger>
	</AccordionPrimitive.Header>
);

type AccordionContentProps = React.ComponentProps<typeof AccordionPrimitive.Content>;
const AccordionContent = ({className, children, ref, ...props}: AccordionContentProps) => (
	<AccordionPrimitive.Content
		ref={ref}
		className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden bg-neutral-800 p-4"
		{...props}
	>
		<div className={cn(className)}>{children}</div>
	</AccordionPrimitive.Content>
);

export {Accordion, AccordionContent, AccordionItem, AccordionTrigger};
